import { Proposta } from "../../components/proposta/Proposta"

export const PropostaPage = () => {
    return (
        <div style={{
            margin: "auto"
        }}>
            <Proposta />
        </div>
    )
}